import db from "./db.js";
import categoryUtil from "./categoryUtil.js";

export default {
  dateString: "YY-MM-DD",
  monthString: "YY-MM",
  isMobile() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  },
  getMobileMixin() {
    return {
      methods: {
        isMobile: this.isMobile,
      },
    };
  },
  getWeekDays() {
    return this.getCurrentWeek().map(d => moment(d, this.dateString).format("ddd"));
  },
  getCurrentDayMoment() {
    return moment()
      .subtract(5, "hours")
      .startOf("day");
  },
  //Returns the current day to be used in retrieving/logging blocks
  getCurrentDay() {
    //FIXME - Deal with timezones?
    //FIXME - Test at midnight to see if we get the right day
    var day = moment()
      .subtract(5, "hours")
      .startOf("day");
    return day.format(this.dateString);
  },
  getCurrentMonth() {
    var day = moment()
      .subtract(5, "hours")
      .startOf("day");
    return day.format(this.monthString);
  },
  getLastXDays(numDays = 7) {
    let days = [];
    let day = moment()
      .subtract(5, "hours")
      .startOf("day");

    for (let i = 0; i < numDays; i++) {
      day.subtract(1, "day");
      days.push(day.format(this.dateString));
    }

    return days.sort();
  },
  getLast7Days() {
    return this.getLastXDays(7);
  },
  getWeek(date = this.getCurrentDay()) {
    let days = [];
    let day = moment(date, this.dateString).day("Sunday");

    for (let i = 0; i < 7; i++) {
      days.push(day.format(this.dateString));
      day.add(1, "day");
    }

    return days.sort();
  },
  //Returns current calendar week as defined by a week starting on Sunday
  getCurrentWeek() {
    return this.getWeek();
  },
  isActiveDay(activeDays = [], date) {
    if (!activeDays) {
      return false;
    }
    return activeDays.includes(moment(date, this.dateString).format("ddd"));
  },
  //Merge new change detected with existing blocks since they are a separate API call
  mergeObjects(newData, oldData) {
    if (Object.keys(oldData).length) {
      for (let key in oldData) {
        if (newData[key]) {
          newData[key] = Object.assign({}, oldData[key], newData[key]);
        }
      }
    }
    return newData;
  },
  //Make sure all categories are normalized regardless of data-loading status from other refs
  //FIXME - Rename to something more applicable
  normalizeCategories(categories) {
    for (let key in categories) {
      let category = categories[key];
      category.id = key;
      //Sum quotas of children
      category.totalQuota = category.quota;
      category.totalBlocks = {};
      if (category.children) {
        //Quota
        Object.keys(category.children)
          .filter(childId => {
            //FIXME - We need to react to removed categories/subcategories instead of breaking please
            if (!categoryUtil.getIsValidCategory(childId)) {
              return false;
            }

            return this.isActiveDay((categories[childId] || {}).activeDays, this.getCurrentDay());
          })
          .forEach(childId => {
            category.totalQuota += categories[childId].quota || 0;
          });
      }
      //Load previous days
      if (!category.days) {
        category.days = {};
        this.getLast7Days().forEach(d => {
          category.days[d] = 0;
        });
      }
    }
    return categories;
  },
  getDefaultBlockColor() {
    return "blue";
  },
  // TODO - Come up with a better solution
  colors: {
    red: "#ff3a24",
    orange: "#e67e22",
    yellow: "#f1c40f",
    green: "#2ecc71",
    turquoise: "#1abc9c",
    blue: "#3498db",
    purple: "#9b59b6",
    pink: "#ff2470",
    lightGray: "#ecf0f1",
    darkGray: "#95a5a6",
    black: "#34495e",
    white: "#ffffff",
  },
};



// WEBPACK FOOTER //
// ./dev/src/util.js